// CheckoutContext.js
import React, { createContext, useContext, useState } from "react";

const CheckoutContext = createContext();

export const useCheckout = () => useContext(CheckoutContext);

export const CheckoutProvider = ({ children }) => {
  const [checkoutState, setCheckoutState] = useState({ status: "idle" });

  return (
    <CheckoutContext.Provider value={{ checkoutState, setCheckoutState }}>
      {children}
    </CheckoutContext.Provider>
  );
};
